// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Uar3WRXIerC1LSzRVq6Ux","main_content":"ffVfhOFjGnfef83y7U7GN","icon":"mPqqczoffqfn13lJE2Iwj","note":"LA0B-lsYsqcv-iukK7Vt-"};